import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2026-02-04 21:02:19 +0100 (Wed, 04 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160321 $
//  Purpose   : generic menu operations for glossary nodes
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { dict } from 'ldash';
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { JobMenuButton } from 'uix/job/components';
export const GlossaryItemUpdate = {
    nodeMenuItem: ({ node, i18n })=>{
        let params = {};
        if (node.type == 'glossary_item') {
            params.ids = [
                node.otid
            ];
        }
        return /*#__PURE__*/ _jsx(JobMenuButton, {
            title: "Update glossary GNDO data via remote API",
            label: "Update",
            name: "GlossaryUpdate",
            params: params
        });
    },
    acl: 'g:admin',
    enabled: ({ node })=>[
            'glossary_domain_container',
            'glossary_item'
        ].includes(node.type)
};
export const GlossaryPatternUpdate = {
    nodeMenuItem: ({ node, i18n })=>{
        return /*#__PURE__*/ _jsx(JobMenuButton, {
            label: "Apply Rules",
            name: "GlossaryAnnotate",
            title: "Calculate glossary include/exclude rules on domain page texts.",
            params: {
                subdomains: true
            }
        });
    },
    acl: 'g:admin',
    enabled: ({ node })=>node.type == 'glossary_domain_container'
};
